export default __webpack_public_path__ + "static/Economic Model Whitepaper - Arabic-14166d042b31b1f5bb5d8e51fd6cfd14.pdf";